/*
document.addEventListener("DOMContentLoaded", function () {
  const url = window.location.href.toLowerCase();
  const hostname = window.location.hostname;
  const protocol = window.location.protocol;
  const params = new URLSearchParams(window.location.search);
  let redirectUrl = null;
  let requiredBrand = null;
  if (url.includes("pages")) {
    switch (true) {
        case url.includes("ariens"):
        requiredBrand = "ARN"; 
        redirectUrl = `${protocol}//${hostname}/pages/ariens-parts?aribrand=`;
        break;
        case url.includes("billy-goat"):
        requiredBrand = "BIL"; 
        redirectUrl = `${protocol}//${hostname}/pages/billy-goat-oem-parts?aribrand=`;
        break;
        case url.includes("briggs-stratton-oem"):
        requiredBrand = "BRG"; 
        redirectUrl = `${protocol}//${hostname}/pages/briggs-stratton-oem-engine-parts?aribrand=`;
        break;
        case url.includes("briggs-stratton-yard"):
        requiredBrand = "MUR"; 
        redirectUrl = `${protocol}//${hostname}/pages/briggs-stratton-yard-power-oem-parts?aribrand=`;
        break;
        //case url.includes("craftsman-eom-parts"):
        //requiredBrand = "needthis1"; 
        //redirectUrl = `${protocol}//${hostname}/pages/craftsman-eom-parts?aribrand=`;
        //break;
        case url.includes("cub-cadet"):
        requiredBrand = "CUT"; 
        redirectUrl = `${protocol}//${hostname}/pages/cub-cadet-oem-parts?aribrand=`;
        break;
        case url.includes("echo-shindaiwa"):
        requiredBrand = "ECH"; 
        redirectUrl = `${protocol}//${hostname}/pages/echo-shindaiwa-oem-parts?aribrand=`;
        break;
        case url.includes("gravely"):
        requiredBrand = "GRV"; 
        redirectUrl = `${protocol}//${hostname}/pages/gravely-oem-parts?aribrand=`;
        break;
        case url.includes("honda-engines"):
        requiredBrand = "HONENG"; 
        redirectUrl = `${protocol}//${hostname}/pages/honda-engines-oem-parts?aribrand=`;
        break;
        case url.includes("honda-power"):
        requiredBrand = "HONPE"; 
        redirectUrl = `${protocol}//${hostname}/pages/honda-power-equipment-oem-parts?aribrand=`;
        break;
        case url.includes("kawasaki"):
        requiredBrand = "KWE"; 
        redirectUrl = `${protocol}//${hostname}/pages/kawasaki-oem-engine-parts?aribrand=`;
        break;
        case url.includes("kohler-engines"):
        requiredBrand = "KOH"; 
        redirectUrl = `${protocol}//${hostname}/pages/kohler-engines-oem-parts?aribrand=`;
        break;
        case url.includes("lawn-boy"):
        requiredBrand = "LBY"; 
        redirectUrl = `${protocol}//${hostname}/pages/lawn-boy-oem-parts?aribrand=`;
        break;
        case url.includes("liquid-combustion-technology"):
        requiredBrand = "LCT"; 
        redirectUrl = `${protocol}//${hostname}/pages/liquid-combustion-technology-oem-parts?aribrand=`;
        break;
        case url.includes("mtd-canada"):
        requiredBrand = "MTD"; 
        redirectUrl = `${protocol}//${hostname}/pages/mtd-canada-oem-parts?aribrand=`;
        break;
        case url.includes("tecumseh-power-oem-parts"):
        requiredBrand = "TPC"; 
        redirectUrl = `${protocol}//${hostname}/pages/tecumseh-power-oem-parts?aribrand=`;
        break;
        case url.includes("toro-parts-residential"):
        requiredBrand = "TO"; 
        redirectUrl = `${protocol}//${hostname}/pages/toro-parts-residential?aribrand=`;
        break;
        case url.includes("toro"):
        requiredBrand = "TCM"; 
        redirectUrl = `${protocol}//${hostname}/pages/toro-landscaper-commercial-parts?aribrand=`;
        break;
        case url.includes("troy-bilt"):
        requiredBrand = "TRB";
        redirectUrl = `${protocol}//${hostname}/pages/troy-bilt-oem-parts?aribrand=`;
        break;
        case url.includes("oregon-oem-parts"):
        requiredBrand = "ORC";
        redirectUrl = `${protocol}//${hostname}/pages/oregon-oem-parts?aribrand=`;
        break;
        case url.includes("stens-parts"):
        requiredBrand = "STE";
        redirectUrl = `${protocol}//${hostname}/pages/stens-parts?aribrand=`;
        break;
        case url.includes("craftsman-eom-parts"):
        requiredBrand = "MTD";
        redirectUrl = `${protocol}//${hostname}/pages/craftsman-eom-parts?aribrand=`;
        break;
        case url.includes("stihl-oem-parts"):
        requiredBrand = "STH";
        redirectUrl = `${protocol}//${hostname}/pages/stihl-oem-parts?aribrand=`;
        break;
        case url.includes("yardworks"):
        requiredBrand = "MTD";
        redirectUrl = `${protocol}//${hostname}/pages/yardworks-oem-parts?aribrand=`;
        break;
        case url.includes("honda-canada"):
        requiredBrand = "HCL";
        redirectUrl = `${protocol}//${hostname}/pages/honda-canada?aribrand=`;
        break;
        default:
        console.log("No keyword match → no redirect check");
        break;
    }
    if (redirectUrl && requiredBrand) {
      const rawBrand = params.get("aribrand") || "";
      const brand = rawBrand.split("/")[0];
      if (brand === requiredBrand) {
        console.log(`Correct brand (${requiredBrand}) → no redirect`);
      } else {
        window.location.href = redirectUrl+requiredBrand;
      }
      document.querySelectorAll(".ari-change-btn").forEach(el => {
        el.setAttribute("href", "#");
      });
    }
  } else {
    console.log("URL does not contain 'pages' → skip checks");
  }

});
*/
/*
(() => {
  const removeDashes = (s) => (s || '').replace(/[\u2010-\u2015\u2212-]/g, '');
  const setCallUsPreserveSpan = (box) => {
    box.querySelectorAll('.ariPLQtyInput, .ariPLCart').forEach((el) => el.remove());
    const priceEl = box.querySelector('.ariPLPrice');
    if (!priceEl) return;
    const nodes = Array.from(priceEl.childNodes);
    for (let i = 0; i < nodes.length; i++) {
      const node = nodes[i];
      if (node.nodeType === Node.TEXT_NODE && node.textContent.trim() !== '') {
        node.textContent = ' Not Available';
        const labelSpan = priceEl.querySelector('.ariPriceLabel');
        if (labelSpan) labelSpan.style.display = 'none';
        return;
      }
    }
    priceEl.appendChild(document.createTextNode(' Call Us'));
  };
  // Reusable fetch attempt
  const tryFetchProductJson = async (skuNoSpaces) => {
    const url = `/products/${encodeURIComponent(skuNoSpaces)}.json`;
    const res = await fetch(url, { credentials: 'same-origin' });
    if (!res.ok) throw new Error(`HTTP ${res.status}`);
    const ct = res.headers.get('content-type') || '';
    if (!ct.includes('application/json')) throw new Error(`Non-JSON: ${ct}`);
    await res.json(); // ensure it parses / isn’t HTML
    return { ok: true, url };
  };

  const processBox = async (box) => {
    if (box.dataset.ariProcessed === '1') return; // don't re-run
    box.dataset.ariProcessed = '1';
    const partEl = box.querySelector('.ariPartNumber');
    if (!partEl) return;
    const rawSku = partEl.textContent || '';
    // SKU variants:
    // A) remove dashes + trim + remove spaces
    const skuNoDash = removeDashes(rawSku).trim().replace(/\s+/g, '');
    // B) preserve dashes + trim + remove spaces
    const skuWithDash = (rawSku || '').trim().replace(/\s+/g, '');
    // Attempt 1: no dashes
    try {
      await tryFetchProductJson(skuNoDash);
      return; // success: do nothing
    } catch (err1) {
      // Attempt 2: with dashes (only if different)
      if (skuWithDash && skuWithDash !== skuNoDash) {
        try {
          await tryFetchProductJson(skuWithDash);
          return; // success on retry
        } catch (err2) {
          console.error('[ARI] product fetch failed (no-dash then dashed) => hiding controls', {
            rawSku,
            skuNoDash,
            skuWithDash,
            err1: err1?.message || err1,
            err2: err2?.message || err2
          });
          setCallUsPreserveSpan(box);
          return;
        }
      }
      // If dashed variant is same as no-dash (or empty), fall back immediately
      console.error('[ARI] product fetch failed => hiding controls', {
        rawSku,
        skuNoDash,
        skuWithDash,
        err: err1?.message || err1
      });
      setCallUsPreserveSpan(box);
    }
  };
  const processAllVisibleBoxes = () => {
    document.querySelectorAll('.ariPartInfo').forEach(processBox);
  };
  processAllVisibleBoxes();
  const observer = new MutationObserver(() => processAllVisibleBoxes());
  observer.observe(document.documentElement, { childList: true, subtree: true });
  window.addEventListener('hashchange', () => processAllVisibleBoxes());
})();
*/

(() => {
  const removeDashes = (s) => (s || '').replace(/[\u2010-\u2015\u2212\-\s]/g, '');

  // Convert spaces AND dots to dashes, collapse multiples
  const normalizeSku = (s) =>
    (s || '')
      .trim()
      .replace(/[.\s]+/g, '-')   // spaces + dots → dash
      .replace(/-+/g, '-');      // collapse multiple dashes

  const setCallUsPreserveSpan = (box) => {
    box.querySelectorAll('.ariPLQtyInput, .ariPLCart').forEach((el) => el.remove());
    const priceEl = box.querySelector('.ariPLPrice');
    if (!priceEl) return;
    const nodes = Array.from(priceEl.childNodes);
    for (let i = 0; i < nodes.length; i++) {
      const node = nodes[i];
      if (node.nodeType === Node.TEXT_NODE && node.textContent.trim() !== '') {
        node.textContent = ' Not Available';
        const labelSpan = priceEl.querySelector('.ariPriceLabel');
        if (labelSpan) labelSpan.style.display = 'none';
        return;
      }
    }
    priceEl.appendChild(document.createTextNode(' Call Us'));
  };

  const tryFetchProductJson = async (handle) => {
    const url = `/products/${encodeURIComponent(handle)}.json`;
    const res = await fetch(url, { credentials: 'same-origin' });
    if (!res.ok) throw new Error(`HTTP ${res.status}`);
    const ct = res.headers.get('content-type') || '';
    if (!ct.includes('application/json')) throw new Error(`Non-JSON: ${ct}`);
    await res.json();
    return { ok: true, url };
  };

  const processBox = async (box) => {
    if (box.dataset.ariProcessed === '1') return;
    box.dataset.ariProcessed = '1';

    const partEl = box.querySelector('.ariPartNumber');
    if (!partEl) return;

    const rawSku = partEl.textContent || '';

    // Normalize once
    const skuDashed = normalizeSku(rawSku);              // spaces + dots → dashes
    const skuNoDash = removeDashes(rawSku); // same but no dashes

    // Attempt 1: no dashes
    try {
      await tryFetchProductJson(skuNoDash);
      return;
    } catch (err1) {
      // Attempt 2: dashed
      if (skuDashed && skuDashed !== skuNoDash) {
        try {
          await tryFetchProductJson(skuDashed);
          return;
        } catch (err2) {
          console.error('[ARI] product fetch failed (no-dash then dashed)', {
            rawSku,
            skuNoDash,
            skuDashed,
            err1: err1?.message || err1,
            err2: err2?.message || err2
          });
          setCallUsPreserveSpan(box);
          return;
        }
      }

      console.error('[ARI] product fetch failed', {
        rawSku,
        skuNoDash,
        skuDashed,
        err: err1?.message || err1
      });
      setCallUsPreserveSpan(box);
    }
  };

  const processAllVisibleBoxes = () => {
    document.querySelectorAll('.ariPartInfo').forEach(processBox);
  };

  processAllVisibleBoxes();
  const observer = new MutationObserver(() => processAllVisibleBoxes());
  observer.observe(document.documentElement, { childList: true, subtree: true });
  window.addEventListener('hashchange', () => processAllVisibleBoxes());
})();


function ARIAddToCart(params) {
  // Parse URL-encoded params provided by PS
  var data = {};
  params.split('&').forEach(function (i) {
    const idx = i.indexOf('=');
    if (idx === -1) return;
    const key = i.slice(0, idx);
    const val = i.slice(idx + 1);
    data[key] = decodeURIComponent(val.replace(/\+/g, ' '));
  });

  if (!data.arisku || !data.ariqty) {
    console.error('Missing SKU or quantity');
    return;
  }

  // Change button text on click
  const btn = document.activeElement;
  if (btn && (btn.tagName === 'BUTTON' || btn.tagName === 'INPUT')) {
    if (btn.tagName === 'BUTTON') {
      const originalText = btn.innerText;
      btn.innerText = 'Added to cart';
      setTimeout(() => (btn.innerText = originalText), 1000);
    } else if (btn.tagName === 'INPUT' && btn.type === 'button') {
      btn.value = 'Item Added';

      const container = btn.closest('.ariPartInfo');
      if (container) {
        container.style.transition = 'background-color 0.3s ease';
        container.style.backgroundColor = '#effff0';
        container.style.color = '#fff';
      }

      const onEnter = () => {
        if (btn.value === 'Item Added') btn.value = 'Add to cart';
      };
      const onLeave = () => {
        if (btn.value === 'Add to cart') btn.value = 'Item Added';
      };

      btn.addEventListener('mouseenter', onEnter);
      btn.addEventListener('mouseleave', onLeave);
    }
  }

  // Normalize: spaces + dots -> dash, collapse multiple dashes
  const normalizeSku = (s) =>
    (s || '')
      .trim()
      .replace(/[.\s]+/g, '-')  // spaces + dots → dash
      .replace(/-+/g, '-');     // collapse --- → -

   const removeDashes = (s) => (s || '').replace(/[\u2010-\u2015\u2212\-\s]/g, '');


  // --- helpers for handle retries ---
  const fetchProductJsonByHandle = async (handle) => {
    const url = `/products/${encodeURIComponent(handle)}.json`;
    const res = await fetch(url);

    if (!res.ok) throw new Error(`HTTP ${res.status} fetching ${url}`);

    const contentType = res.headers.get('content-type') || '';
    if (!contentType.includes('application/json')) {
      const text = await res.text().catch(() => '');
      throw new Error(`Non-JSON response (${contentType}) for ${url}: ${text.slice(0, 120)}`);
    }

    const json = await res.json();
    return { json, url, handle };
  };

  // Build handles:
  // A) no-dash: remove dash chars, then convert spaces/dots to dashes (end result: no dashes)
  // B) dashed: convert spaces/dots to dashes (keep dashes)
  const targetSkuRaw = (data.arisku || '').trim();
  const handleWithDash = normalizeSku(targetSkuRaw);
  const handleNoDash = normalizeSku(removeDashes(targetSkuRaw)).replace(/-/g, ''); // ensure no dashes at all

  console.log('ARI sku raw:', targetSkuRaw);
  console.log('handle tried (no dash):', handleNoDash);
  console.log('handle tried (with dash):', handleWithDash);

  (async () => {
    let productData, productUrl, handleUsed;

    // Attempt 1: no-dash
    try {
      const r1 = await fetchProductJsonByHandle(handleNoDash);
      productData = r1.json;
      productUrl = r1.url;
      handleUsed = r1.handle;
    } catch (err1) {
      // Attempt 2: dashed
      if (handleWithDash && handleWithDash !== handleNoDash) {
        try {
          const r2 = await fetchProductJsonByHandle(handleWithDash);
          productData = r2.json;
          productUrl = r2.url;
          handleUsed = r2.handle;
        } catch (err2) {
          console.error('Product JSON request failed (no-dash then dashed)', {
            rawSku: targetSkuRaw,
            handleNoDash,
            handleWithDash,
            err1: err1?.message || err1,
            err2: err2?.message || err2
          });
          return;
        }
      } else {
        console.error('Product JSON request failed', {
          rawSku: targetSkuRaw,
          handleNoDash,
          handleWithDash,
          err: err1?.message || err1
        });
        return;
      }
    }

    // --- existing variant lookup logic ---
    let variantId = null;

    // Match against variant SKU using the SAME normalization rules
    const targetSkuNorm = normalizeSku(targetSkuRaw);
    const targetSkuNoDashNorm = removeDashes(targetSkuRaw).replace(/-/g, '');

    const product = productData.product || productData;
    if (!product || !product.variants) {
      console.error('Product not found for handle:', handleUsed, 'url:', productUrl);
      return;
    }

    product.variants.forEach((variant) => {
      const variantSkuRaw = (variant.sku || '').trim();
      const variantSkuNorm = normalizeSku(variantSkuRaw);
      const variantSkuNoDashNorm = removeDashes(variantSkuRaw).replace(/-/g, '');

      // Prefer exact raw match if it happens
      if (!variantId && variantSkuRaw === targetSkuRaw) variantId = variant.id;

      // Normalized dashed match
      if (!variantId && variantSkuNorm === targetSkuNorm) variantId = variant.id;

      // Normalized no-dash match (safety net)
      if (!variantId && variantSkuNoDashNorm === targetSkuNoDashNorm) variantId = variant.id;
    });

    if (!variantId) {
      console.error('SKU not found in product variants:', data.arisku, {
        handleUsed,
        productUrl
      });
      return;
    }

    // Add to Shopify cart
    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: parseInt(data.ariqty, 10) })
      });

      if (!res.ok) {
        const text = await res.text().catch(() => '');
        console.error('Cart add failed', {
          status: res.status,
          statusText: res.statusText,
          response: text.slice(0, 200)
        });
        throw new Error(`HTTP ${res.status} adding to cart`);
      }

      const cartItem = await res.json();

      if (cartItem) {
        const drawerEl = document.querySelector('cart-drawer');
        if (drawerEl && typeof drawerEl.refresh === 'function') {
          const isOpen = drawerEl.getAttribute('open') !== null;
          drawerEl.refresh(isOpen ? false : true);
        } else {
          document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:refresh'));
        }
      }
    } catch (error) {
      console.error('Error adding to cart:', error);
    }
  })();
}
/*
function ARIAddToCart(params) {
  // Parse URL-encoded params provided by PS
  var data = {};
  params.split('&').forEach(function (i) {
    const idx = i.indexOf('=');
    if (idx === -1) return;
    const key = i.slice(0, idx);
    const val = i.slice(idx + 1);
    data[key] = decodeURIComponent(val.replace(/\+/g, ' '));
  });
  if (!data.arisku || !data.ariqty) {
    console.error('Missing SKU or quantity');
    return;
  }
  // Change button text on click
  const btn = document.activeElement;
  if (btn && (btn.tagName === 'BUTTON' || btn.tagName === 'INPUT')) {
    if (btn.tagName === 'BUTTON') {
      const originalText = btn.innerText;
      btn.innerText = 'Added to cart';
      setTimeout(() => (btn.innerText = originalText), 1000);
    } else if (btn.tagName === 'INPUT' && btn.type === 'button') {
      const originalValue = btn.value;
      btn.value = 'Item Added';
      // Change container background to blue
      const container = btn.closest('.ariPartInfo');
      if (container) {
        container.style.transition = 'background-color 0.3s ease';
        container.style.backgroundColor = '#effff0';
        container.style.color = '#fff';
      }
      // Hover override: show "Add to cart" when hovered
      const onEnter = () => {
        if (btn.value === 'Item Added') btn.value = 'Add to cart';
      };
      const onLeave = () => {
        if (btn.value === 'Add to cart') btn.value = 'Item Added';
      };
      btn.addEventListener('mouseenter', onEnter);
      btn.addEventListener('mouseleave', onLeave);
    }
  }

  // --- helpers for handle retries ---
  const fetchProductJsonByHandle = async (handle) => {
    const url = `/products/${encodeURIComponent(handle)}.json`;
    const res = await fetch(url);
    if (!res.ok) {
      throw new Error(`HTTP ${res.status} fetching ${url}`);
    }
    const contentType = res.headers.get('content-type') || '';
    if (!contentType.includes('application/json')) {
      const text = await res.text().catch(() => '');
      throw new Error(`Non-JSON response (${contentType}) for ${url}: ${text.slice(0, 120)}`);
    }
    const json = await res.json();
    return { json, url, handle };
  };
  // Build handles:
  // A) existing behavior: strip non-alphanumeric (removes dashes)
  // B) retry behavior: keep dashes, only remove whitespace
  const targetSkuRaw = (data.arisku || '').trim();
  const handleNoDash = targetSkuRaw.replace(/[^a-zA-Z0-9]/g, '');
  const handleWithDash = targetSkuRaw.replace(/\s+/g, ''); // preserves '-' and other punctuation
  console.log('ARI sku raw:', targetSkuRaw);
  console.log('handle tried (no dash):', handleNoDash);
  console.log('handle tried (with dash):', handleWithDash);
  (async () => {
    let productData, productUrl, handleUsed;
    // Attempt 1: no-dash (current behavior)
    try {
      const r1 = await fetchProductJsonByHandle(handleNoDash);
      productData = r1.json;
      productUrl = r1.url;
      handleUsed = r1.handle;
    } catch (err1) {
      // Attempt 2: dashed (only if different / non-empty)
      if (handleWithDash && handleWithDash !== handleNoDash) {
        try {
          const r2 = await fetchProductJsonByHandle(handleWithDash);
          productData = r2.json;
          productUrl = r2.url;
          handleUsed = r2.handle;
        } catch (err2) {
          console.error('Product JSON request failed (no-dash then dashed)', {
            rawSku: targetSkuRaw,
            handleNoDash,
            handleWithDash,
            err1: err1?.message || err1,
            err2: err2?.message || err2
          });
          return;
        }
      } else {
        console.error('Product JSON request failed', {
          rawSku: targetSkuRaw,
          handleNoDash,
          handleWithDash,
          err: err1?.message || err1
        });
        return;
      }
    }

    // --- existing variant lookup logic (kept the same) ---
    let variantId = null;
    // store both raw and space-removed forms of input SKU
    const targetSkuNoSpace = targetSkuRaw.replace(/[^a-zA-Z0-9]/g, '');
    const product = productData.product || productData; // handles either structure
    if (!product || !product.variants) {
      console.error('Product not found for handle:', handleUsed, 'url:', productUrl);
      return;
    }
    product.variants.forEach((variant) => {
      const variantSku = (variant.sku || '').trim();
      const variantSkuNoSpace = variantSku.replace(/[^a-zA-Z0-9]/g, '');
      // First check exact match (with spaces)
      if (variantSku === targetSkuRaw) {
        variantId = variant.id;
      }
      // If not matched yet, check without spaces/punctuation
      if (!variantId && variantSkuNoSpace === targetSkuNoSpace) {
        variantId = variant.id;
      }
    });
    if (!variantId) {
      console.error('SKU not found in product variants:', data.arisku, {
        handleUsed,
        productUrl
      });
      return;
    }
    // Add to Shopify cart
    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: parseInt(data.ariqty, 10) })
      });
      if (!res.ok) {
        const text = await res.text().catch(() => '');
        console.error('Cart add failed', {
          status: res.status,
          statusText: res.statusText,
          response: text.slice(0, 200)
        });
        throw new Error(`HTTP ${res.status} adding to cart`);
      }
      const cartItem = await res.json();
      if (cartItem) {
        const drawerEl = document.querySelector('cart-drawer');
        if (drawerEl && typeof drawerEl.refresh === 'function') {
          const isOpen = drawerEl.getAttribute('open') !== null;
          drawerEl.refresh(isOpen ? false : true);
        } else {
          document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:refresh'));
        }
      }
    } catch (error) {
      console.error('Error adding to cart:', error);
    }
  })();
} */
/*
function ARIAddToCart(params) {
  // Parse URL-encoded params provided by PS
  var data = {};
  params.split('&').forEach(function (i) {
    const idx = i.indexOf('=');
    if (idx === -1) return;
    const key = i.slice(0, idx);
    const val = i.slice(idx + 1);
    data[key] = decodeURIComponent(val.replace(/\+/g, ' '));
  });
  if (!data.arisku || !data.ariqty) {
    console.error('Missing SKU or quantity');
    return;
  }
// Change button text on click
const btn = document.activeElement;
if (btn && (btn.tagName === 'BUTTON' || btn.tagName === 'INPUT')) {
  if (btn.tagName === 'BUTTON') {
    const originalText = btn.innerText;
    btn.innerText = 'Added to cart';
    setTimeout(() => (btn.innerText = originalText), 1000);
  } else if (btn.tagName === 'INPUT' && btn.type === 'button') {
    const originalValue = btn.value;
    btn.value = 'Item Added';

    // Change container background to blue
    const container = btn.closest('.ariPartInfo');
    if (container) {
      container.style.transition = 'background-color 0.3s ease';
      container.style.backgroundColor = '#effff0';
      container.style.color = '#fff';
    }

    // Hover override: show "Add to cart" when hovered
    const onEnter = () => {
      if (btn.value === 'Item Added') btn.value = 'Add to cart';
    };
    const onLeave = () => {
      if (btn.value === 'Add to cart') btn.value = 'Item Added';
    };

    btn.addEventListener('mouseenter', onEnter);
    btn.addEventListener('mouseleave', onLeave);
  }
}

  // Lookup variant ID from products.json because PS is dumb
  const targetSku = data.arisku.trim();
    const targetSkuInitNoSpace = targetSku.replace(/[^a-zA-Z0-9]/g, '');
      console.log(targetSkuInitNoSpace)
    console.log(targetSku)
 
 fetch(`/products/${targetSkuInitNoSpace}.json`)
  .then(async (res) => {
    // Guard BEFORE res.json()
    if (!res.ok) {
      console.error('Product JSON request failed', {
        status: res.status,
        statusText: res.statusText,
        url: res.url,
        handleTried: targetSkuInitNoSpace
      });
      throw new Error(`HTTP ${res.status} fetching ${res.url}`);
    }
    // Optional: extra safety if Shopify returns HTML
    const contentType = res.headers.get('content-type') || '';
    if (!contentType.includes('application/json')) {
      const text = await res.text();
      console.error('Expected JSON but got:', { contentType, text: text.slice(0, 200) });
      throw new Error(`Non-JSON response: ${contentType}`);
    }
    return res.json();
  })
  .then((productData) => {
    let variantId = null;
    let productTitle = '';
    let vendor = '';
    let handle = '';
    // store both raw and space-removed forms of input SKU
    const targetSkuRaw = data.arisku.trim();
    const targetSkuNoSpace = targetSkuRaw.replace(/[^a-zA-Z0-9]/g, '');
    // Shopify returns a single product, not a products array
    const product = productData.product || productData; // handles either structure
    if (!product || !product.variants) {
      console.error('Product not found for handle:', targetSkuInitNoSpace);
      return;
    }
    product.variants.forEach((variant) => {
      const variantSku = (variant.sku || '').trim();
      const variantSkuNoSpace = variantSku.replace(/[^a-zA-Z0-9]/g, '');
      // First check exact match (with spaces)
      if (variantSku === targetSkuRaw) {
        variantId = variant.id;
        productTitle = product.title;
        vendor = product.vendor;
        handle = product.handle;
      }
      // If not matched yet, check without spaces
      if (!variantId && variantSkuNoSpace === targetSkuNoSpace) {
        variantId = variant.id;
        productTitle = product.title;
        vendor = product.vendor;
        handle = product.handle;
      }
    });
    if (!variantId) {
      console.error('SKU not found:', data.arisku);
      return;
    }
    // Add to Shopify cart
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: parseInt(data.ariqty, 10) })
    })
      .then(async (res) => {
        // Guard BEFORE res.json() here too
        if (!res.ok) {
          const text = await res.text().catch(() => '');
          console.error('Cart add failed', {
            status: res.status,
            statusText: res.statusText,
            response: text.slice(0, 200)
          });
          throw new Error(`HTTP ${res.status} adding to cart`);
        }
        return res.json();
      })
      .then((cartItem) => {
        if (!cartItem) return;
        const drawerEl = document.querySelector('cart-drawer');
        if (drawerEl && typeof drawerEl.refresh === 'function') {
          const isOpen = drawerEl.getAttribute('open') !== null;
          drawerEl.refresh(isOpen ? false : true);
        } else {
          document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:refresh'));
        }
      });
  })
  .catch((error) => console.error('Error adding to cart:', error));
}*/
// Update or create cart icon bubble on add to cart
function updateCartIcon() {
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
        .then(res => res.json())
        .then(cart => {
            const bubble = document.querySelector('#cart-icon-bubble');
            if (!bubble) return;
            let countEl = bubble.querySelector('.header__cart-count');
            if (countEl) {
                // Update existing
                const numberSpan = countEl.querySelector('.header__cart-count-number');
                const visuallyHidden = countEl.querySelector('span.visually-hidden');
                if (numberSpan) numberSpan.textContent = cart.item_count;
                if (visuallyHidden) visuallyHidden.textContent = `${cart.item_count} items`;
            } else {
                // Create if it doesn't exist
                const newCount = document.createElement('div');
                newCount.className = 'header__cart-count absolute bg-theme-text text-theme-bg text-center';
                newCount.innerHTML = `
                    <span aria-hidden="true" class="header__cart-count-number">${cart.item_count}</span>
                    <span class="visually-hidden">${cart.item_count} items</span>
                `;
                bubble.appendChild(newCount);
            }
        })
        .catch(err => console.error('Failed to update cart icon:', err));
}
document.addEventListener("click", function (e) {
  const el = e.target.closest("a[href='javascript:;']");
  if (el) {
    e.preventDefault();   // stops navigation / new tab behavior
    console.log("Intercepted javascript:; link");
  }
});

// assets/predictive-add.js

(function(){
  // simple helpers
  function closest(el, sel){ return el && el.closest(sel); }
  function text(el){ return (el && (el.textContent || el.innerText) || '').trim(); }

  // Expose a single function the inline button calls.
  // This guarantees the handler runs even when the HTML is injected by the predictive component.
  window.PS_LogAndAdd = async function(btn){
    try {
      // ---- LOG THE CLICK (you said console events aren't firing; this forces them to) ----
      const itemEl = btn.closest('.predictive-search__item');
      const title = itemEl ? text(itemEl.querySelector('.predictive-result__title')) : null;
      const variantIdFromData = btn.getAttribute('data-variant-id') || null;

      console.log({
        event: 'PredictiveSearchAddClick',
        time: new Date().toISOString(),
        product_title: title,
        variant_id_attr: variantIdFromData,
        // we log the currently selected variant (from select/hidden) below too
      });

      // ---- GATHER INPUTS ----
      const zone = btn.closest('[data-ps-actions]');
      const variantEl = zone && zone.querySelector('.ps-variant');
      const qtyEl = zone && zone.querySelector('.ps-qty');

      const id = (variantEl && variantEl.value) || variantIdFromData;
      const quantity = Math.max(1, parseInt((qtyEl && qtyEl.value) || '1', 10));

      console.log({
        event: 'PredictiveSearchResolvedInputs',
        variant_id_final: id,
        quantity,
        time: new Date().toISOString()
      });

      if (!id) {
        btn.textContent = 'Select option';
        console.warn('PredictiveSearchAdd: Missing variant id');
        return false;
      }

      // ---- UI STATE ----
      const prev = btn.textContent;
      btn.disabled = true;
      btn.textContent = 'Adding…';

      // ---- ADD TO CART ----
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id, quantity })
      })
      .then((res) => res.json())
        .then((cartItem) => {
  if (!cartItem) return;
  const drawerEl = document.querySelector('cart-drawer');
  if (drawerEl && typeof drawerEl.refresh === 'function') {
    // If the drawer is open refresh it
    // If it's closed, do a full section refresh but stays closed
    const isOpen = drawerEl.getAttribute('open') !== null;
    drawerEl.refresh(isOpen ? false : true);
  } else {
    // Fallback: just ask the theme to refresh; DO NOT open.
    document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:refresh'));
  }
})
/*
      if (!res.ok) {
        let msg = 'Add failed';
        try { const j = await res.json(); if (j?.description || j?.message) msg = j.description || j.message; } catch(_) {}
        console.error('PredictiveSearchAddError', msg);
        btn.textContent = 'Error';
        setTimeout(() => { btn.textContent = prev; btn.disabled = false; }, 1200);
        return false;
      }
*/
      // ---- SUCCESS LOG ----
      console.log({
        event: 'PredictiveSearchAddSuccess',
        variant_id: id,
        quantity,
        time: new Date().toISOString()
      });

      // Nudge cart UIs; adjust if your theme listens for a different event
      document.dispatchEvent(new CustomEvent('cart:refresh'));
      document.dispatchEvent(new CustomEvent('cart:updated'));

      btn.textContent = 'Added ✓';
      setTimeout(() => { btn.textContent = prev; btn.disabled = false; }, 900);
      return false;
    } catch (err) {
      console.error('PredictiveSearchAddException', err);
      try { btn.textContent = 'Error'; setTimeout(() => { btn.textContent = 'Add to cart'; btn.disabled = false; }, 1200); } catch(_){}
      return false;
    }
  };
})();
document.addEventListener('DOMContentLoaded', () => {
  const target = document.querySelector('.shopify-section.cc-media-with-text');
  if (target) {
    target.id = 'fmp'; // assign your ID
    console.log('Added id="fmp" to:', target);
  }
});
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.item.ari-settings').forEach(el => {
    const span = document.createElement('span');
    span.className = 'anchorParts';

    const link = document.createElement('a');
    link.href = '#'; // dummy, since we handle scroll manually
    link.textContent = 'How do I find my part #?';

    link.addEventListener('click', e => {
      e.preventDefault(); // stop URL change
      const target = document.querySelector('#fmp');
      if (target) {
        // Smooth scroll to element without modifying URL
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });

    span.appendChild(link);
    el.insertAdjacentElement('afterend', span);
  });
});

(() => {
  const inject = () => {
    const container = document.querySelector('.ariSearchBlock');
    if (!container || container.querySelector('.ari-injected-note')) return;

    const p = document.createElement('p');
    p.className = 'ari-injected-note';
    p.textContent = 'Having an issue finding your part or model? Make sure to include any dashes or spaces from your equipments numbering system.';

    container.appendChild(p);
  };

  inject();
  const observer = new MutationObserver(inject);
  observer.observe(document.documentElement, { childList: true, subtree: true });
})();


document.addEventListener('click', async (e) => {
  const btn = e.target.closest('#clear-cart');
  if (!btn) return;
  e.preventDefault();
  btn.disabled = true;
  btn.setAttribute('aria-busy', 'true');
  try {
    const res = await fetch('/cart/clear.js', {
      method: 'POST',
      headers: { 'Accept': 'application/json' }
    });
    if (window.location.pathname.startsWith('/cart')) {
      window.location.reload();
    } else {
      /*
      document.dispatchEvent(new CustomEvent('cart:refresh'));
      document.dispatchEvent(new CustomEvent('cart:updated', { detail: { item_count: 0 } }));
      const bubbles = document.querySelectorAll('[data-cart-count], .cart-count-bubble, .cart-count');
      bubbles.forEach(el => el.textContent = '0');
      */
     window.location.reload();
    }
  } catch (err) {
    console.error('Failed to clear cart', err);
    btn.disabled = false;
    btn.removeAttribute('aria-busy');
    alert('Sorry—couldn’t clear the cart. Please try again.');
  }
});

/**
 * JAVASCRIPT DEVELOPER DOCUMENTATION
 *
 * Enterprise is a powerful and customizable theme designed for large-scale e-commerce stores. Built
 * using Web Components, it offers a highly modular architecture that makes customization and
 * maintenance easier than ever. In addition, Enterprise is optimized for speed, ensuring that your
 * store runs as fast as possible to provide your customers with a seamless shopping experience.
 *
 * If you would like to add your own JS to Enterprise, we recommend using this file and referencing
 * it using Theme Settings > Advanced > Custom HTML.
 *
 * As a brief overview, Enterprise:
 *  - Broadcasts many JS events.
 *  - Is built using Web Components.
 *  - Follows a 'code splitting' architecture.
 *  - Is completely custom built (no JS libraries other than instant.page)
 *  - Has a number of JS utilities.
 *
 *
 *
 * =================================================================================================
 * Custom JavaScript Events
 * =================================================================================================
 *
 * Enterprise broadcasts many custom events for ease of extensibility, detailed in this section.
 *
 * When in the Theme Editor, the details of each custom event will be logged out in the Dev Tools
 * console everytime it is triggered.
 *
 * Events are named in the following convention: ["on/dispatch"]:[subject]:[action] (where
 * 'dispatch' will trigger an event to occur, and 'on' indicates an event has occurred).
 *
 * All 'Return data' detailed in this section is returned within the 'event.detail' object.
 *
 * The available events are:
 *  1.  on:variant:change
 *  2.  on:cart:add
 *  3.  on:cart:error
 *  4.  on:line-item:change
 *  5.  on:cart-drawer:before-open
 *  6.  on:cart-drawer:after-open
 *  7.  on:cart-drawer:after-close
 *  8.  on:quickbuy:before-open
 *  9.  on:quickbuy:after-open
 *  10. on:quickbuy:after-close
 *  11. dispatch:cart-drawer:open
 *  12. dispatch:cart-drawer:refresh
 *  13. dispatch:cart-drawer:close
 *  14. on:debounced-resize
 *  15. on:breakpoint-change
 *
 * -------------------------------------------------------------------------------------------------
 * 1) on:variant:change
 * -------------------------------------------------------------------------------------------------
 * Fires whenever a variant is selected (e.g. Product page, Quickbuy, Featured Product etc).
 *
 * How to listen:
 * document.addEventListener('on:variant:change', (event) => {
 *  // your code here
 * });
 *
 * Returned data:
 *  - form: the product form content
 *  - variant: the selected variant object
 *  - product: the product object (includes a list of all variants)
 *
 *
 * -------------------------------------------------------------------------------------------------
 * 2) on:cart:add
 * -------------------------------------------------------------------------------------------------
 * Fires when a variant has been added to the cart, where it didn't exist in the cart before. This
 * event does not fire when the added variant was already in the cart. To listen for this, see the
 * on:line-item:change event.
 *
 * How to listen:
 * document.addEventListener('on:cart:add', (event) => {
 *   // your code here
 * });
 *
 * Returned data:
 *   - cart: the new cart object after the variant was added
 *   - variantId: id of the variant that was just added to the cart
 *
 *
 * -------------------------------------------------------------------------------------------------
 * 3) on:line-item:change
 * -------------------------------------------------------------------------------------------------
 * Fires when the quantity of an item already in the cart is updated. Note, if the 'newQuantity' is
 * 0, this indicates the item was removed from that cart.
 *
 * Note, when adding a variant to the cart - this event will fire if that variant is already in the
 * cart (i.e. the quantity is incremented). In this situation, 'on:cart:add' will not fire.
 *
 * How to listen:
 * document.addEventListener('on:line-item:change', (event) => {
 *   // your code here
 * });
 *
 * Returned data:
 *   - cart: the new cart object after the quantity change was completed
 *   - variantId: id of the variant that was just updated
 *   - newQuantity: new quantity of the line item
 *   - oldQuantity: old quantity of the line item
 *
 *
 * -------------------------------------------------------------------------------------------------
 * 4) on:cart:error
 * -------------------------------------------------------------------------------------------------
 * Fires when an action related to the cart has failed, for example adding too much quantity of an
 * item to the cart.
 *
 * How to listen:
 * document.addEventListener('on:cart:error', (event) => {
 *   // your code here
 * });
 *
 * Returned data:
 *   - error: the error message
 *
 *
 * -------------------------------------------------------------------------------------------------
 * 5) on:cart-drawer:before-open
 * -------------------------------------------------------------------------------------------------
 * Fires before the cart drawer opens.
 *
 * How to listen:
 * document.addEventListener('on:cart-drawer:before-open', (event) => {
 *   // your code here
 * });
 *
 *
 * -------------------------------------------------------------------------------------------------
 * 6) on:cart-drawer:after-open
 * -------------------------------------------------------------------------------------------------
 * Fires after the cart drawer has finished opening.
 *
 * How to listen:
 * document.addEventListener('on:cart-drawer:after-open', (event) => {
 *   // your code here
 * });
 *
 *
 * -------------------------------------------------------------------------------------------------
 * 7) on:cart-drawer:after-close
 * -------------------------------------------------------------------------------------------------
 * Fires after the cart drawer has finished closing.
 *
 * How to listen:
 * document.addEventListener('on:cart-drawer:after-close', (event) => {
 *   // your code here
 * });
 *
 *
 * -------------------------------------------------------------------------------------------------
 * 8) on:quickbuy:before-open
 * -------------------------------------------------------------------------------------------------
 * Fires before the quick buy drawer opens.
 *
 * How to listen:
 * document.addEventListener('on:quickbuy:before-open', (event) => {
 *   // your code here
 * });
 *
 *
 * -------------------------------------------------------------------------------------------------
 * 9) on:quickbuy:after-open
 * -------------------------------------------------------------------------------------------------
 * Fires after the quick buy drawer has finished opening.
 *
 * How to listen:
 * document.addEventListener('on:quickbuy:after-open', (event) => {
 *   // your code here
 * });
 *
 *
 * -------------------------------------------------------------------------------------------------
 * 10) on:quickbuy:after-close
 * -------------------------------------------------------------------------------------------------
 * Fires after the quick buy drawer has finished closing.
 *
 * How to listen:
 * document.addEventListener('on:quickbuy:after-close', (event) => {
 *   // your code here
 * });
 *
 *
 * -------------------------------------------------------------------------------------------------
 * 11) dispatch:cart-drawer:open
 * -------------------------------------------------------------------------------------------------
 * Opens the cart drawer (if enabled in the Theme Settings).
 *
 * How to trigger:
 * document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:open'));
 *
 * You can optionally pass in a 'detail' object with a property of 'opener', which specifies the DOM
 * element that should be focussed on when the drawer is closed.
 *
 * Example:
 * document.getElementById('header-search').addEventListener('keydown', (evt) => {
 *   if (evt.keyCode === 67) {
 *     evt.preventDefault();
 *     document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:open', {
 *       detail: {
 *         opener: evt.target
 *       }
 *     }));
 *   }
 * });
 *
 * In this example, we attach a keydown listener to the search input in the header. If the user
 * presses the 'c' key, it prevents the default behavior (which would be to type the letter 'c' in
 * the input) and dispatches the 'dispatch:cart-drawer:open' event with a 'detail' object that
 * specifies the search input as the opener. When the cart drawer is closed, focus is returned to
 * the search input.
 *
 *
 * -------------------------------------------------------------------------------------------------
 * 12) dispatch:cart-drawer:refresh
 * -------------------------------------------------------------------------------------------------
 * Refreshes the contents of the cart drawer.
 *
 * This event is useful when you are adding variants to the cart and would like to instruct the
 * theme to re-render the cart drawer.
 *
 * How to trigger:
 * document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:refresh', {
 *   bubbles: true
 * }));
 *
 *
 * -------------------------------------------------------------------------------------------------
 * 13) dispatch:cart-drawer:close
 * -------------------------------------------------------------------------------------------------
 * Closes the cart drawer.
 *
 * How to trigger:
 * document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:close'));
 *
 *
 * -------------------------------------------------------------------------------------------------
 * 14) on:debounced-resize
 * -------------------------------------------------------------------------------------------------
 * Fires when the viewport finishes resizing (debounced to 300ms by default).
 *
 * How to listen:
 * window.addEventListener('on:debounced-resize', (event) => {
 *   // your code here
 * });
 *
 *
 * -------------------------------------------------------------------------------------------------
 * 15) on:breakpoint-change
 * -------------------------------------------------------------------------------------------------
 * Fires when the breakpoint of the viewport changes. See the 'Media Queries' section in this file
 * for more.
 *
 * Example:
 * window.addEventListener('on:breakpoint-change', (event) => {
 *  if (theme.mediaMatches.md) {
 *   console.log('we are not on mobile');
 *  }
 * });
 *
 *
 *
 * =================================================================================================
 * Web Components
 * =================================================================================================
 *
 * Enterprise utilizes Web Components to the fullest.
 *
 * Web Components are a set of standardized APIs that allow developers to create custom, reusable
 * HTML elements that can be used across different web pages and applications.
 * Web Components consist of three main technologies: Custom Elements, Shadow DOM and HTML
 * Templates.
 *
 * See Mozilla for more: https://developer.mozilla.org/en-US/docs/Web/Web_Components
 *
 *
 *
 * =================================================================================================
 * Third-Party JavaScript Dependencies
 * =================================================================================================
 *
 * Enterprise only has one third-party dependency: instant.page (https://instant.page/).
 *
 * It's included locally and is only active if it has been enabled in
 * 'Theme Settings > Advanced > Preload links on hover'.
 *
 * Instant.page is a JavaScript library that speeds up page loads by preloading links as soon as the
 * customer hovers over them.
 *
 *
 *
 * =================================================================================================
 * Code Splitting
 * =================================================================================================
 * We followed the ‘code splitting’ technique when building Enterprise.
 *
 * Code splitting consists in writing JavaScript (and CSS)in a modularized way within typically
 * small, more manageable files that can be loaded on-demand, as needed. The idea is to improve the
 * performance of our theme by reducing the amount of code that needs to be loaded upfront.
 *
 * If the customer is visiting a specific page of the theme that requires certain JavaScript
 * functionality, only the code needed for that page will be loaded, rather than one large
 * JavaScript file containing largely unused code. For example, the file media-gallery.js will
 * only be loaded if there is a media gallery on the page.
 *
 * Shopify uses HTTP/2, which is the newer version of the HTTP protocol used to deliver web content.
 * HTTP/2 supports multiplexing, which means that multiple requests can be sent over a single
 * connection at the same time - meaning multiple JS files are essentially served at the speed of a
 * single file.
 *
 * The only JS file which is served on every page in Enterprise is 'main.js'. Main.js contains
 * utility JS which is likely to be needed by many scripts. This is outlined more in the next
 * section.
 *
 *
 *
 * =================================================================================================
 * Utilities
 * =================================================================================================
 * Enterprise provides a few utility utilities, contained in main.js. Some of the key ones are
 * outlined below. See main.js for more.
 *
 *
 * -------------------------------------------------------------------------------------------------
 * 1) Lazy Loading
 * -------------------------------------------------------------------------------------------------
 * Lazy loading is a technique for delaying the loading of certain elements until they are needed,
 * which can help improve page load times.
 *
 * We use three functions used for lazy loading images and scripts in our theme:
 *
 *  - setImageSources function - copies the data-src and data-srcset attributes of lazy loaded
 *    images to their src and srcset attributes.
 *  - initLazyScript function - only loads a script when a specific element is scrolled into view.
 *
 *
 * -------------------------------------------------------------------------------------------------
 * 2) Cookies
 * -------------------------------------------------------------------------------------------------
 * Cookies are small pieces of data that can be stored on a user's computer. They can be useful for
 * tracking user activity, remembering user preferences or other similar purposes.
 *
 * We use three functions to manage cookies:
 *
 *  - setCookie function - sets a cookie with a given name, value and number of days until it
 *  should expire.
 *  - getCookie function - takes in the name of a cookie to retrieve its value.
 *  - deleteCookie function - takes in the name of a cookie to delete it.
 *
 *
 * -------------------------------------------------------------------------------------------------
 * 3) Media Queries
 * -------------------------------------------------------------------------------------------------
 * The theme creates a theme.mediaMatches object (in theme.liquid) for several key screen sizes
 * specified in our theme, and adds listeners for each media query.
 *
 * These are:
 *
 * mediaQueries: {
 *  sm: '(min-width: 600px)',
 *  md: '(min-width: 769px)',
 *  lg: '(min-width: 1024px)',
 *  xl: '(min-width: 1280px)',
 *  xxl: '(min-width: 1536px)',
 *  portrait: '(orientation: portrait)'
 * }
 *
 * If a breakpoint is crossed, the mediaMatches values are updated and an 'on:breakpoint-change'
 * event is dispatched.
 *
 * You can request the entire theme.mediaMatches object to check which media queries are currently
 * matched. In this case, the returned data will be an object with the names of the media queries as
 * keys, and boolean values indicating whether they are currently matched or not.
 *
 * Example:
 *
 * {
 *  sm: true,
 *  md: true,
 *  lg: true,
 *  xl: true,
 *  xxl: false,
 *  portrait: false
 * }
 *
 * You can reference a specific media query to check if it's currently matched by using:
 * theme.mediaMatches.lg.
 *
 * To check if you're on mobile you can use:
 * !theme.mediaMatches.md
 *
 * If you want to perform some action when the breakpoint changes, you can listen for the
 * breakpoint-change event on the window object.
 *
 * Example:
 * window.addEventListener('on:breakpoint-change', (event) => {
 *  // your code here
 * });
 *
 * =================================================================================================
 *
 * Have fun! - The Clean Canvas Development Team.
 */
